import type { SVGProps } from 'react';

export type IconName =
  | 'home'
  | 'users'
  | 'leaf'
  | 'building'
  | 'user'
  | 'shield'
  | 'flag'
  | 'sparkles'
  | 'chat'
  | 'chevron'
  | 'chevdown'
  | 'plus'
  | 'check'
  | 'arrow'
  | 'heart'
  | 'bookmark'
  | 'doc'
  | 'bag'
  | 'clock'
  | 'star'
  | 'pin'
  | 'bolt'
  | 'eye'
  | 'cog'
  | 'download'
  | 'trash'
  | 'lock'
  | 'inbox'
  | 'grid'
  | 'activity'
  | 'money'
  | 'clip'
  | 'image'
  | 'smile'
  | 'dots'
  | 'camera'
  | 'mic'
  | 'filter'
  | 'checkcheck'
  | 'search'
  | 'back'
  | 'x'
  | 'file'
  | 'globe'
  | 'crown'
  | 'userplus'
  | 'key'
  | 'sliders'
  | 'calendar'
  | 'ban'
  | 'megaphone'
  | 'layers'
  | 'toggle'
  | 'pill'
  | 'drop'
  | 'trendup'
  | 'trenddown'
  | 'minus';

const paths: Record<IconName, string> = {
  home: `<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/><path d="M9.5 21v-6h5v6"/>`,
  users: `<circle cx="9" cy="8" r="3.2"/><path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5"/><path d="M16 4.5a3.2 3.2 0 0 1 0 7"/><path d="M17.5 14.6c2.5.5 4.5 2.4 4.5 5.4"/>`,
  leaf: `<path d="M11 21c-5-1-8-5-8-11 6 0 10 1 13 4"/><path d="M21 4c0 9-4 14-10 16"/>`,
  building: `<rect x="4" y="3" width="16" height="18" rx="1.5"/><path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2"/><path d="M10 21v-3h4v3"/>`,
  user: `<circle cx="12" cy="8" r="3.6"/><path d="M5 20c0-3.6 3-6 7-6s7 2.4 7 6"/>`,
  shield: `<path d="M12 3 5 6v6c0 4 3 7 7 9 4-2 7-5 7-9V6Z"/><path d="m9.5 12 1.8 1.8 3.4-3.6"/>`,
  flag: `<path d="M5 21V4"/><path d="M5 5h11l-1.5 3L16 11H5"/>`,
  sparkles: `<path d="M12 4v6M9 7h6"/><path d="M6 14v4M4 16h4"/><path d="M17 14l1 3 3 1-3 1-1 3-1-3-3-1 3-1Z"/>`,
  chat: `<path d="M4 5h16v11H9l-4 4Z"/><path d="M8 10h8M8 13h5"/>`,
  chevron: `<path d="m9 6 6 6-6 6"/>`,
  chevdown: `<path d="m6 9 6 6 6-6"/>`,
  plus: `<path d="M12 5v14M5 12h14"/>`,
  check: `<path d="m5 12 4.5 4.5L19 7"/>`,
  arrow: `<path d="M5 12h14M13 6l6 6-6 6"/>`,
  heart: `<path d="M12 20s-7-4.3-9.2-9C1.4 8 3 5 6 5c2 0 3.2 1.4 4 2.4C10.8 6.4 12 5 14 5c3 0 4.6 3 3.2 6-2.2 4.7-9.2 9-9.2 9Z"/>`,
  bookmark: `<path d="M6 4h12v17l-6-4-6 4Z"/>`,
  doc: `<path d="M7 3h7l4 4v14H7Z"/><path d="M14 3v4h4"/><path d="M10 12h5M10 16h5"/>`,
  bag: `<path d="M6 8h12l-1 12H7Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>`,
  clock: `<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>`,
  star: `<path d="M12 4l2.3 4.8 5.2.7-3.8 3.6.9 5.2L12 16.6 7.4 18.3l.9-5.2L4.5 9.5l5.2-.7Z"/>`,
  pin: `<path d="M12 21s6-5.3 6-10a6 6 0 1 0-12 0c0 4.7 6 10 6 10Z"/><circle cx="12" cy="11" r="2.2"/>`,
  bolt: `<path d="M13 3 5 13h5l-1 8 8-10h-5Z"/>`,
  eye: `<path d="M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12Z"/><circle cx="12" cy="12" r="2.6"/>`,
  cog: `<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/>`,
  download: `<path d="M12 4v10M8 11l4 4 4-4"/><path d="M5 19h14"/>`,
  trash: `<path d="M5 7h14M9 7V5h6v2M7 7l1 13h8l1-13"/>`,
  lock: `<rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>`,
  inbox: `<path d="M4 13l2-8h12l2 8v6H4Z"/><path d="M4 13h5a3 3 0 0 0 6 0h5"/>`,
  grid: `<rect x="4" y="4" width="7" height="7" rx="1"/><rect x="13" y="4" width="7" height="7" rx="1"/><rect x="4" y="13" width="7" height="7" rx="1"/><rect x="13" y="13" width="7" height="7" rx="1"/>`,
  activity: `<path d="M3 12h4l2.5 7 5-14L17 12h4"/>`,
  money: `<rect x="3" y="6" width="18" height="12" rx="2"/><circle cx="12" cy="12" r="2.6"/><path d="M6 12h.01M18 12h.01"/>`,
  clip: `<path d="M20 11.5 12.5 19a4.5 4.5 0 0 1-6.4-6.3l7.6-7.7a3 3 0 0 1 4.3 4.3l-7.6 7.6a1.5 1.5 0 0 1-2.2-2.1l6.9-7"/>`,
  image: `<rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.5" cy="10" r="1.8"/><path d="m4 18 5-5 4 4 2.5-2.5L20 17"/>`,
  smile: `<circle cx="12" cy="12" r="8.5"/><path d="M8.5 14.5s1.3 1.8 3.5 1.8 3.5-1.8 3.5-1.8"/><path d="M9 9.5h.01M15 9.5h.01"/>`,
  dots: `<circle cx="5" cy="12" r="1.4"/><circle cx="12" cy="12" r="1.4"/><circle cx="19" cy="12" r="1.4"/>`,
  camera: `<path d="M4 8h3l1.5-2h7L17 8h3v11H4Z"/><circle cx="12" cy="13" r="3.2"/>`,
  mic: `<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/>`,
  filter: `<path d="M4 6h16M7 12h10M10 18h4"/>`,
  checkcheck: `<path d="m2.5 12.5 4 4L15 8"/><path d="m11 16 1.5 1.5L21 9"/>`,
  search: `<circle cx="11" cy="11" r="7"/><path d="m20 20-3-3"/>`,
  back: `<path d="M19 12H5M11 18l-6-6 6-6"/>`,
  x: `<path d="M6 6l12 12M18 6 6 18"/>`,
  file: `<path d="M7 3h7l4 4v14H7Z"/><path d="M14 3v4h4"/>`,
  globe: `<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17M12 3.5c2.5 2.4 2.5 14.6 0 17M12 3.5c-2.5 2.4-2.5 14.6 0 17"/>`,
  crown: `<path d="M4 17h16l1-9-5 3.5L12 5 8 11.5 3 8Z"/><path d="M4 20h16"/>`,
  userplus: `<circle cx="9" cy="8" r="3.4"/><path d="M3 20c0-3.4 2.7-5.6 6-5.6 1.2 0 2.3.3 3.2.8"/><path d="M18 14v6M15 17h6"/>`,
  key: `<circle cx="8" cy="14" r="4"/><path d="m11 11 8-8M16 3l3 3M14 5l2.5 2.5"/>`,
  sliders: `<path d="M4 8h10M18 8h2M4 16h2M10 16h10"/><circle cx="16" cy="8" r="2.2"/><circle cx="8" cy="16" r="2.2"/>`,
  calendar: `<rect x="4" y="5" width="16" height="16" rx="2"/><path d="M4 9h16M9 3v4M15 3v4"/>`,
  ban: `<circle cx="12" cy="12" r="8.5"/><path d="m6 6 12 12"/>`,
  megaphone: `<path d="M4 10v4l11 5V5L4 10Z"/><path d="M15 8a4 4 0 0 1 0 8M7 14v4a2 2 0 0 0 4 0"/>`,
  layers: `<path d="m12 3 9 5-9 5-9-5 9-5Z"/><path d="m3 13 9 5 9-5"/>`,
  toggle: `<rect x="2.5" y="7" width="19" height="10" rx="5"/><circle cx="16" cy="12" r="3"/>`,
  pill: `<path d="M10.5 3.5 3.5 10.5a5 5 0 0 0 7 7l7-7a5 5 0 0 0-7-7Z"/><path d="M7 7l7 7"/>`,
  drop: `<path d="M12 3.2S6 10 6 14a6 6 0 0 0 12 0c0-4-6-10.8-6-10.8Z"/>`,
  trendup: `<path d="M3 17l6-6 4 4 8-8"/><path d="M15 7h6v6"/>`,
  trenddown: `<path d="M3 7l6 6 4-4 8 8"/><path d="M15 17h6v-6"/>`,
  minus: `<path d="M5 12h14"/>`,
};

type IconProps = SVGProps<SVGSVGElement> & { name: IconName; size?: number };

export const Icon = ({ name, size = 18, ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
    dangerouslySetInnerHTML={{ __html: paths[name] }}
  />
);
